<script lang="ts">
    import { onMount } from 'svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { mainMenu, planning } from '../../../stores/store';
    import TemplateHeaderUno from '../../shared/TemplateHeaderUno.svelte';
    import { api, customerSettings, mla } from '../../../stores/api';
    import { debug } from '../../../stores/store';
    import { EasyVrpApp } from './EasyVrpApp';
    import EasyVrpForm from './EasyVrpForm.svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import WarningColor from '../../shared/WarningColor.svelte';
    import { vehiclesManager } from '../Vehicles/VehiclesApp/vehiclesManager';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import LinkSmallDanger from '../../shared/LinkSmallDanger.svelte';
    import { EasyVrpApi } from './EasyVrpApi';
    import { app as mainApp } from '../../../stores/app';

    const localStorageKey = 'easyVrpOptions_' + $mainApp.account.getCustomerId().toString();
    let loadingResults: boolean = true;
    let loadingCountStats: boolean = true;

    let app: EasyVrpApp = new EasyVrpApp(options => {
        localStorage.setItem(localStorageKey, JSON.stringify(options));
    });

    app.setOptions(JSON.parse(localStorage.getItem(localStorageKey) || '{}'));

    app.setDefaultServiceTimeOnStopIfNotSet($customerSettings.each_stop_minutes, true);
    app.setDefaultServiceTimePerPackageIfNotSet($customerSettings.each_delivery_minutes, true);
    app.setDefaultCostPerKmIfNotSet($customerSettings.route_cost.per_km, true);
    app.setDefaultCostPerMinuteIfNotSet($customerSettings.route_cost.per_min, true);
    app.setDefaultCostPerItemIfNotSet($customerSettings.route_cost.per_item, true);
    app.setDefaultWarehouseStartTimeIfNotSet($customerSettings.planning.start_time_route, true);
    app.setSelectedDay($planning.selectedDay);

    onMount(() => {
        loadingResults = true;
        loadingCountStats = true;
        $mainMenu.currentPage = 'PageEasyVrp';
        Promise.all([onMapReady(), $vehiclesManager.triggerReload()]).then(() => {
            // verify that all vehicles from app.getSelectedVehicleIds() are in $vehiclesManager.getItems()
            const selectedVehicleIds = app.getSelectedGroupedVehicleIds();
            const appVehicles = $vehiclesManager.getItems();
            const missingVehicles = selectedVehicleIds.filter(
                vehicleId => !appVehicles.some(vehicle => vehicle.getId() === vehicleId)
            );
            if (missingVehicles.length > 0) {
                alert(
                    `Niektóre wybrane wcześniej pojazdy nie są już dostępne: ${missingVehicles.join(
                        ', '
                    )}. Lista wybranych pojazdów zostanie zresetowana`
                );
                app.setSelectedGroupedVehicleIds(
                    $vehiclesManager.getItems().map(vehicle => vehicle.getId() as number)
                );
            }

            app.loadCountStats($api).then(_ => {
                app = app;
                loadingCountStats = false;
            });
            app.getResultsApp()
                .loadResults($api)
                .then(() => {
                    app = app;
                    loadingResults = false;
                })
                .catch(error => {
                    console.error('Error loading results:', error);
                });
            app.setTimeoutToCheckResults(
                5,
                $api,
                () => {
                    console.log('Triggering results check');
                    app = app;
                },
                $vehiclesManager.getItems()
            );
            $mla.reloadLayer(Targeo.Base.Map, 'vrp');
        });

        return () => {
            app.destroy();
        };
    });
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderUno>
            <div slot="main-header">Easy VRP</div>
        </TemplateHeaderUno>
    </div>
    <div slot="content-header"></div>
    <div slot="monit"></div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        {#if loadingResults || loadingCountStats}
            <div style="padding: 10px; text-align: left;">
                <IconPending spin={true} scale={0.6} />
            </div>
        {:else}
            {#if app.getCountStats().historical_jobs <= 0 && !loadingCountStats}
                <WarningColor>
                    <div style="padding: 10px; text-align: left;">
                        Nie znaleziono żadnych zleceń historycznych - wyliczone trasy nie będą miały
                        uwzględnionej historii zleceń.
                    </div>
                </WarningColor>
            {/if}
            {#if app.getCountStats().unassigned_jobs <= 0 && !loadingCountStats}
                <WarningColor>
                    <div style="padding: 10px; text-align: left;">
                        Nie znaleziono żadnych zleceń do przypisania. Zaimportuj lub dodaj ręcznie
                        zlecenia, aby móc wyliczyć trasy.
                    </div>
                </WarningColor>
            {/if}

            {#if $debug}
                <div>
                    Zleceń historycznych: {app.getCountStats().historical_jobs}
                    <br />
                    <LinkSmallDanger
                        text="Usuń zlecenia historyczne"
                        on:click={() => {
                            (async () => {
                                loadingCountStats = true;
                                await app.removeHistoryJobs($api);
                                await app.loadCountStats($api);
                                await EasyVrpApi.createHexes($api);
                                $mla.reloadLayer(Targeo.Base.Map, 'vrp');
                                app = app;
                                loadingCountStats = false;
                            })();
                        }}
                    />
                    <br />
                    Zleceń do przypisania: {app.getCountStats().unassigned_jobs}
                    <br />
                    Pojazdów: {$vehiclesManager.getItems().length}
                </div>
            {/if}
            {#if app.getCountStats().unassigned_jobs > 0 || $debug}
                <EasyVrpForm bind:app />
            {/if}
        {/if}
    </div>
    <div slot="footer"></div>
</TemplateStandard>
